import { GetterTree } from 'vuex';
import { RootState } from '@/store/index';
import { APP_IS_IDLE, GLOBAL_ERROR } from '@/types/store.types';
import { AxiosError } from 'axios';

export const getters: GetterTree<RootState, RootState> = {

  [APP_IS_IDLE](state): boolean {
    return state.idleVue.isIdle;
  },

  [GLOBAL_ERROR](state): AxiosError | null {
    return state.globalError;
  },

};
